import React from 'react';

import {useI18n} from '../../../../../data/hooks/i18nHooks';
import styles from './FullTag.module.scss';

const FullTag = props => {
    const {className, session} = props,
        i18n = useI18n();

    if (!session.is_full) return null;

    return <span className={[styles.FullTag, className].join(' ')}>{i18n['label.full']}</span>;
};

export default FullTag;
